import { render, staticRenderFns } from "./orderRow.vue?vue&type=template&id=bb2ade38&scoped=true"
import script from "./orderRow.vue?vue&type=script&lang=js"
export * from "./orderRow.vue?vue&type=script&lang=js"
import style0 from "./orderRow.vue?vue&type=style&index=0&id=bb2ade38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2ade38",
  null
  
)

export default component.exports